import { d as e } from "./index-Buti0PLx.js";
var R = {};
const {
  DECENTRIQ_HOST: _,
  DECENTRIQ_PORT: t,
  DECENTRIQ_USE_TLS: o,
  DECENTRIQ_CLIENT_LOG_REQUESTS: s,
  DECENTRIQ_REQUEST_RETRY_TOTAL: E,
  DECENTRIQ_REQUEST_RETRY_BACKOFF_FACTOR: a,
  _DECENTRIQ_UNSAFE_DISABLE_KNOWN_ROOT_CA_CHECK: r
} = typeof e.process < "u" && e.process.env || R || {}, n = {
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  host: _ || "api.decentriq.com",
  port: t ? parseInt(t) : 443,
  useTls: o !== void 0 ? o === "true" : !1,
  clientLogRequests: s !== void 0 ? s === "true" : !1,
  requestRetryTotal: E ? parseInt(E) : 3,
  requestRetryBackoffFactor: a ? parseFloat(a) : 2,
  unsafeDisableKnownRootCaCheck: r !== void 0 ? r === "true" : !1
};
export {
  n as default
};
//# sourceMappingURL=config.js.map
